import { useEffect } from 'react';

import type { Post } from '~/interfaces/post';
import type { PostTemplate } from '~/interfaces/post_template';

import { useNonRevalidatingFetcher } from '../useNonRevalidatingFetcher';
import type { SetCookieOptions } from '../useUtils/useCookies';

interface Props {
  visitToken: string;
  post: Post | PostTemplate;
  pageViews: string;
  setCookie: (options: SetCookieOptions) => void;
  cookiesSet: boolean;
  skip?: boolean;
}

type FetcherData = {
  status: 'success' | 'error';
};

const useCreatePageView = ({ visitToken, post, pageViews, setCookie, cookiesSet, skip = false }: Props) => {
  const fetcher = useNonRevalidatingFetcher<() => Promise<FetcherData>>();
  const pageView = pageViews?.includes(post?.id);

  const shouldCreatePageView = !skip && cookiesSet && visitToken && post?.id && !pageView;
  const cookieKey = 'page_view';

  useEffect(() => {
    if (shouldCreatePageView) {
      const referrer = document.referrer;
      const formData = new FormData();
      formData.append('postId', post.id);
      formData.append('webTitle', post.web_title);
      formData.append('slug', post.slug);
      formData.append('landingPage', window.location.href);
      formData.append('referrer', referrer);
      formData.append('visitToken', visitToken);
      const newPageViews = pageViews ? `${pageViews},${post.id}` : post.id;

      fetcher.submit(formData, { method: 'post', action: '/page_view' });
      const tenMinutes = 600000 / (24 * 60 * 60 * 1000);
      setCookie({ name: cookieKey, value: newPageViews, days: tenMinutes });
    }
  }, [shouldCreatePageView]);
};

export default useCreatePageView;
